<div class="form-group" [ngClass]="{ 'no-margin' : !hasMarginB}">
  <label *ngIf="label">{{label}}<span class="red" *ngIf="requiredMark">*</span></label>
      <!-- [textMask]="{mask: mask, placeholderChar: '\u2000'}" -->
  <div [class.input-group]="prefix || suffix" [class.mb-3]="prefix">
    <div class="input-group-prepend" *ngIf="prefix">
        <span class="input-group-text" id="basic-addon3">{{prefix}}</span>
    </div>
    <input
      [tabindex]="tabId"
      [type]="inputType"
      [(ngModel)]="model"
      [autocomplete]="autocomplete"
      placeholder="{{placeholder}}"
      class="form-control {{inputClasses}}"
      [ngClass]="{'is-invalid': hasValidationError()}"
      (blur)="onBlur($event)"
      [id]="'input-' + formControlName"
      (input)="onChange($event)"
      [disabled]="currentControl.disabled">

    <div class="input-group-append" *ngIf="suffix">
      <span class="input-group-text" id="basic-addon3">{{suffix}}</span>
    </div>

    <div class="invalid-feedback" *ngIf="hasValidationError()">
        {{invalidMsg}}
    </div>
  </div>
</div>
